import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { withRouter } from 'react-router'
import WorkoutForm from '../WorkoutForm'
import PageHeader from 'components/util/PageHeader'
import { FormattedMessage } from 'react-intl'
import { Modal, Loader, Svg } from 'components/util'
import { ImportWorkouts, GoMobile } from 'components/sidebar'
import styles from './_editWorkoutPage.css'
import * as workoutActions from 'services/workouts/actions'
import * as workoutSelectors from 'services/workouts/selectors'
import Ad from 'components/util/ads/Ad'
import { AD_SIZES } from 'services/ads/constants'

const mapStateToProps = state => ({
  saving: workoutSelectors.selectWorkoutSaving(state),
  defaultWorkout: workoutSelectors.selectInitialFormData(state),
  originalWorkout: workoutSelectors.selectWorkoutCopy(state),
  loading: workoutSelectors.selectWorkoutCopyLoading(state),
})

const mapDispatchToActions = {
  ...workoutActions,
}

export class LogWorkoutPage extends Component {

  static propTypes = {
    updateWorkout: PropTypes.func,
    saving: PropTypes.bool,
    fetchWorkoutCopy: PropTypes.func,
    defaultWorkout: PropTypes.object,
    originalWorkout: PropTypes.object,
    loading: PropTypes.bool,
    match: PropTypes.object,
  }

  state = {
    saving: false,
    error: false,
    workoutToCopy: null,
  }

  componentWillMount () {
    const { workoutId } = this.props.match.params
    this.props.fetchWorkoutCopy(workoutId)
      .catch(() => this.setState({ error: true }))
  }

  handleSubmit = (values) => {
    const { originalWorkout } = this.props
    const id = originalWorkout._links.self[0].id

    this.setState({ saving: true })
    this.props.updateWorkout(values, id)
      .then(() => { window.location.href = `/workout/${id}/` })
      .catch(() => this.setState({ saving: false }))
  }

  render () {
    const { error, saving } = this.state
    const { defaultWorkout, loading } = this.props

    return (
      <Row>
        <Col xs={12} sm={8}>

          <PageHeader>
            <h1 className={styles.title}>
              <FormattedMessage
                id='workouts.create.edit_this_workout'
                defaultMessage='Edit this workout'
              />
            </h1>
          </PageHeader>

          <div className={styles.description}>
            <Svg name='dumbbell_circle' className={styles.dumbbell} />
            <p>
              <FormattedMessage
                id='workouts.create.description'
                defaultMessage={`
                  If you\'ve been active, get credit for it!
                  Add your workout details below, and stay on top of your fitness goals.
                `}
              />
            </p>
          </div>

          {loading ?
            <div className={styles.pageLoader}>
              <Loader type='pulse' />
            </div>
          : null}

          {!loading && defaultWorkout ?
            <WorkoutForm
              mode='edit'
              defaultWorkout={defaultWorkout}
              className={styles.workoutForm}
              onSubmit={this.handleSubmit}
            />
          : null}

          {error ?
            <div className={styles.error}>
              <FormattedMessage
                id='workout.create.error_loading_workout'
                defaultMessage='Error loading workout'
              />
            </div>
          : null}

          <Modal isOpen={saving} preventBodyScroll={false}>
            <div className={styles.loadingModal}>
              <div>
                <Loader height={50} width={50} />
              </div>
              <h3 className={styles.loadingTitle}>
                <FormattedMessage
                  id='workout.create.saving_workout'
                  defaultMessage='Saving workout...'
                />
              </h3>
            </div>
          </Modal>

        </Col>

        <Col xs={12} sm={4}>
          <ImportWorkouts />
          <Ad sizes={[AD_SIZES.RAIL_2]} />
          <GoMobile />
          <Ad sizes={[AD_SIZES.RAIL_2]} position={'bottom'} />
        </Col>

      </Row>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(withRouter(LogWorkoutPage))
